import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 1 }

import { ref, computed, watch, watchEffect, h } from "vue";
import { VideoPlay, VideoPause } from "@element-plus/icons-vue";
import { PauseModule, IReasonList, IStatus } from "@/store/modules/Pause";
import { AuthModule } from "@/store/modules/Auth";
import { socket } from "@/main";
import { useRoute } from "vue-router";
import { env } from "@/config";
import { CallDataModule } from "@/store/modules/CallData";
import { AppModule } from "@/store/modules/app";
import { AlertModule } from "@/store/modules/Alert";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
//Raealizar acciones dependiendo del estado de la ruta
watchEffect(() => {
	if (route.matched[0].name === "CallCenter" || env.onlyCallcenter) {
		PauseModule.setStatus(IStatus.CALLCENTER); //Estatus call center
		PauseModule.updatePauseCallReason(); //Solo la primera vez cuando se carga
	} else {
		PauseModule.setStatus(IStatus.CHATCENTER); //Setea el status chatcenter
	}
});

//Raealizar acciones dependiendo del estado de la pausa, ya sea call center o chatcenter

watch(
	() => [PauseModule.paused, PauseModule.reasonPause],
	() => {
		model.value.loading = false;
		model.value.isReady = !PauseModule.paused;
		model.value.reasonPause = PauseModule.reasonPause ?? "";
	}
);

const model = ref({
	isReady: !PauseModule.paused,
	loading: false,
	reasonPause: PauseModule.reasonPause,
});
const visible = ref(false);
const selectReason = ref(false);

const reasons = computed(() => PauseModule.reasons ?? []);
const loading = computed(() => PauseModule.loading);
const togglePopover = (show: boolean) => {
	visible.value = show;
};

const switchChange = () => {
	model.value.loading = true;
	if (PauseModule.paused) ready();
	else visible.value = true;
	return false;
};

const pause = (reason: IReasonList) => {
	if (PauseModule.status == IStatus.CHATCENTER) {
		PauseModule.setLoading(true);
		socket.emit("SET_PAUSADO", {
			token: AuthModule.token,
			idPausa: reason._id,
		});
	} else {
		if (reason.active || !AppModule.appConfig.pause_limit_strict)
			PauseModule.pauseAgent(reason._id);
		else
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				type: "warning",
				text: "Límite de pausa alcanzada, no puede realizar esta operación",
			});
	}
	model.value.reasonPause = reason.razon;
	selectReason.value = true;
};

const stopLoading = () => {
	model.value.loading = false;
};

const ready = () => {
	visible.value = false;
	selectReason.value = false;
	PauseModule.status == IStatus.CHATCENTER
		? socket.emit("SET_LISTO", { token: AuthModule.token })
		: PauseModule.readyAgent();
};
const omniConfig = computed(() =>
	AppModule.configs.find(c => c.name === "omnichannel_config")
);
const enabledControls = computed(() => {
	return (
		!CallDataModule.getenableControls &&
		!(
			PauseModule.status === IStatus.CHATCENTER &&
			(omniConfig.value?.data[0] as any)?.pause_disabled
		)
	);
});

// => Methods
const getTime = ({ pause }: { pause: IReasonList }) => {
	const countdown = pause.time - (pause.used ?? 0);
	let text = "";
	if (countdown >= 3600) {
		text = `${Math.floor(countdown / (60 * 60))
			.toString()
			.padStart(2, "0")}:${(Math.floor(countdown / 60) % 60)
			.toString()
			.padStart(2, "0")}h`;
	} else if (countdown < 0) {
		text = "00:00";
	} else
		text = `${Math.floor(countdown / 60)
			.toString()
			.padStart(2, "0")}:${(countdown % 60).toString().padStart(2, "0")}`;
	return h(
		"span",
		{
			class: {
				"ml-auto": true,
				"my-auto": true,
				"text-muted": countdown > 60,
			},
			style: {
				color:
					countdown <= 30 ? "#b4190e" : countdown <= 60 ? "#b77f0f" : "inherit",
			},
		},
		[text]
	);
};

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_popover, {
      placement: "bottom",
      title: "Motivo de Pausa",
      visible: visible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      trigger: "manual",
      onHide: stopLoading,
      width: 200
    }, {
      reference: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_switch, {
          disabled: !_unref(enabledControls),
          modelValue: model.value.isReady,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.isReady) = $event)),
          "inline-prompt": "",
          "active-icon": _unref(VideoPlay),
          "inactive-icon": _unref(VideoPause),
          loading: model.value.loading || _unref(loading),
          "before-change": switchChange,
          "inactive-color": "#ECA71E",
          onMouseenter: _cache[1] || (_cache[1] = () => _unref(PauseModule).paused && togglePopover(true)),
          onMouseleave: _cache[2] || (_cache[2] = () => _unref(PauseModule).paused && togglePopover(false))
        }, null, 8, ["disabled", "modelValue", "active-icon", "inactive-icon", "loading"]), [
          [_directive_click_outside, () => togglePopover(false)]
        ])
      ]),
      default: _withCtx(() => [
        (model.value.isReady)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(reasons), (reason) => {
              return (_openBlock(), _createElementBlock("a", {
                key: reason._id,
                onClick: ($event: any) => (pause(reason)),
                class: _normalizeClass([{
						'text-muted': !reason.active,
					}, "dropdown-item"]),
                style: {"display":"inline-flex"}
              }, [
                _createElementVNode("span", null, _toDisplayString(reason.razon), 1),
                (_unref(PauseModule).status === _unref(IStatus).CALLCENTER)
                  ? (_openBlock(), _createBlock(getTime, {
                      key: 0,
                      pause: reason
                    }, null, 8, ["pause"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_1))
            }), 128))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(model.value.reasonPause), 1))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})